<template>
  <div id="russian-game" class="game">
    <router-link to="/" tag="div" class="close">×</router-link>
    <h1>Russian roulette</h1>
    <form class="game-wrapper layout-1" @submit="pull_trigger">
      <div class="layout-content">
        <div id="russian-pistol" :class="{'pulled': pulled}"></div>
      </div>
      <div class="layout-navigation"><button class="action-button">Pull the trigger</button></div>
      <div id="shot" v-if="shot"></div>
    </form>
  </div>
</template>

<script>

import Random from './../utils/random'

const FIRE = '/audio/russian/fire.mp3';
const NO = '/audio/russian/no.mp3';

export default {
  data: function () {
    return {
      'value': null,
      'up': true,
      'pulled': false,
      'shot': false,
      'accepted': false
    }
  },
  methods: {
    pull_trigger: function (e) {
      e.preventDefault();
      if (!this.$data.accepted){
        if (confirm('It may be unexpectedly loud and may startle you. Do you accept this risk?')){
          this.$data.accepted = true;
        } else {
          this.$router.push({'name': 'homepage'});
          return;
        }
      }
      const res = Random.getNumber(0, 5);
      this.$data.pulled = true;
      setTimeout(() => {
        (new Audio(NO)).play();
        if (!res) {
          (new Audio(FIRE)).play();
          this.$data.shot = true;
          setTimeout(() => this.$data.shot = false, 2000);
        }
        this.$data.pulled = false;
      }, 250);
    }
  }
}
</script>

<style src="./../assets/css/game.css" scoped></style>
<style scoped>
  div#russian-game {
    background-image: url('../assets/img/game/russian/bg.jpg');
  }

  div#russian-game div#russian-pistol {
    position: relative;
    width: 80%;
    height: 80%;
    margin: 5%;
    left: 0;
    background: url("./../assets/img/game/russian/pistol.png") 50% 50% no-repeat;
    background-size: contain;
    transition: left 0.25s linear;
  }

  div#russian-game div#russian-pistol.pulled {
    left: 25px;
  }

  #shot {
    position: fixed;
    z-index: 99;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #000000;
  }

</style>
